<template>
  <div class="researchCard" ref="root">
    <div class="date">
      <!-- <p class="month">
        <span class="month">{{ data.month }}</span>月
      </p>
      <p class="year">{{ data.year }}年</p> -->
      <img src="@/assets/paper-T.png">
    </div>
    <div class="line" v-for="(item, index) in data" :key="item.Id" @click="$router.push('/studyResult/detail?id=' + item.id+'&type=report')">
      <span class="line-l" :title="item.title">{{ item.title }}</span>
      <span class="line-c">{{ item.author }}</span>
      <span class="line-r">{{ item.date }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'researchCard',
  props: {
    // {year: '', month: '', list: [{title: '', author: '', date: ''}, ...]}
    // data: {
    //   type: Object,
    //   required: true
    // },

    // [{title: '', author: '', date: '', id: ''}, ...]
    data: {
      type: Array,
      required: true
    },
    width: {
      type: String,
      required: false,
      default: '1144px'
    }
  },
  mounted() {
    // TODO: 不知道是否可以这样处理，因为此处px2rem不生效
    this.$refs.root.style.width = parseInt(this.width) * (1144 / 1920) + 'px'
  }
}
</script>

<style lang="scss" scoped>
  .researchCard {
    position: relative;
    padding: 50px 10%;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.35);
    color: #333;
    cursor: pointer;
  }
  .date {
    position: absolute;
    left: 25px;
    top: 25px;
    display: flex;
    flex-direction: column;
    width: 74px;
    img {
      width: 45px;
      height: 45px;
    }
  }
  // .month {
  //   font-size: 20px;
  // }
  // .month span {
  //   font-size: 48px;
  //   color: #0087d3;
  //   font-weight: bold;
  // }
  // .year {
  //   color: #c5c5c7;
  //   font-size: 18px;
  //   text-align: center;
  // }
  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    line-height: 65px;
    border-bottom: 2px solid #e9e9e9;
    font-size: 16px;
  }
  .line-l {
    width: 70%;
    @include hideTextOverflow;
    &:hover {
      text-decoration: underline;
    }
  }
  .line-c {
    width: 10%;
    text-align: center;
  }
  .line-r {
    width: 20%;
    text-align: right;
  }
</style>
